/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from "react-router-dom";

const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate()
    const handleSubmit = (e) => {
        e.preventDefault();

        // Add your login logic here, e.g., send a request to your authentication server
        if (email === "Greeen" && password === "Haze"){
            localStorage.setItem("H1LI", "LoOWorld")
            navigate('/admin')
        }else{
            alert("Wrong login data")
        }
    };

    return (
        <div>
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card mt-5">
                        <div className="card-header">
                            <h3>Авторизация</h3>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label>Логин:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Логин"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Пароль:</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Пароль"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>
                                {/*TODO УБРАТЬ ЭТОТ ЕБАНЫЙ КОСТЫЛЬ*/}
                                <br />
                                <button type="submit" className="btn btn-primary">
                                    Авторизация
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
